/* eslint-disable class-methods-use-this */
import { InsignGameAuth, INSIGN_PHASE } from '@inface-sdk/web-game-auth'
import ServiceHandler from './ServiceHandler.class'

export default class GameAuthService {
  constructor({
    gid, env, locale, country,
  }) {
    this.insignGameAuth = new InsignGameAuth({
      gid, env, locale, country,
    })

    this.$t = window.$i18next.t
  }

  get phase() {
    return this.insignGameAuth.currentInsignPhase || this.insignGameAuth.popInsignPhase()
  }

  get isAccountLinkPhase() {
    return this.phase === INSIGN_PHASE.SA_AL_NX_LOGIN
  }

  setPhase(phase = this.insignGameAuth.currentInsignPhase) {
    console.debug('[GW]::setPhase::', phase)
    if (phase) {
      this.insignGameAuth.setInsignPhase(phase)
    }
  }

  async handleResponse(response) {
    const handler = new ServiceHandler(response)
    if (!handler.success) {
      await window.$globalModal.warning(handler.getErrorModalData())
    }
  }

  // ******** start of api call *******
  async issueIasTicketByWebToken() {
    const response = await this.insignGameAuth.issueIasTicketByWebToken()
    await this.handleResponse(response)
    return response
  }

  async recoverUser(ticket) {
    const response = await this.insignGameAuth.recoverUser(ticket)
    await this.handleResponse(response)
    return response
  }
  // ******** end of api call *******

  async transactionByPhase(queryParams) {
    const { currentInsignPhase } = this.insignGameAuth
    const { guid, ticket } = queryParams

    let response
    console.debug('[GW]::transactionByPhase::', currentInsignPhase)

    switch (currentInsignPhase) {
      case INSIGN_PHASE.PN_TERMS_ERROR_FROM_GA_INIT_GT:
        response = await this.insignGameAuth.expireGameToken()
        console.debug('[GW]::expireGameToken()::', response)
        await this.handleResponse(response)
        break
      case INSIGN_PHASE.IAC_TERMS_ERROR_FROM_GA_INIT_GT:
        response = await this.insignGameAuth.logoutUser()
        console.debug('[GW]::logoutUser()::', response)
        await this.handleResponse(response)
        break
      case INSIGN_PHASE.PN_TERMS_CONSENT_FROM_GA_INIT_LC:
      case INSIGN_PHASE.IAC_TERMS_CONSENT_FROM_GA_LOGIN_WT:
      case INSIGN_PHASE.IAC_TERMS_CONSENT_FROM_PN_AL_AC:
        response = await this.insignGameAuth.issueGameToken(guid, ticket)
        console.debug('[GW]::issueGameToken()::', response)
        await this.handleResponse(response)
        break
      case INSIGN_PHASE.IAC_TERMS_CONSENT_FROM_PN_AL_SUCCESS:
        response = await this.insignGameAuth.issueGameToken(guid, ticket)
        console.debug('[GW]::issueGameToken()::', response)

        // 넥슨계정 연동 완료 안내
        if (response.success) {
          await window.$globalModal.warning({ message: this.$t('account_link_complete_message', { ns: 'playnow' }) })
        } else {
          await this.handleResponse(response)
        }
        break
      default:
    }
  }

  /**
   * 계정연동 성공 시 기존 게임토큰을 서버에서 날리기 때문에 쿠키에서 제거만.
   */
  processRemovePNSession() {
    try {
      this.insignGameAuth.removeLocalCredential()
      this.insignGameAuth.removeGameToken()
    } catch (e) {
      console.error('[GW] error::processRemoveSession()::', e)
    }
  }

  async processLogoutWithLC() {
    try {
      this.insignGameAuth.removeLocalCredential()
      await this.processLogout()
    } catch (e) {
      console.error('[GW] error::processLogoutWithLC()::', e)
    }
  }

  async processLogout() {
    try {
      const isLogin = await this.insignGameAuth.isLogin
      if (isLogin) {
        const response = await this.insignGameAuth.logoutUser()
        await this.handleResponse(response)
      }
    } catch (e) {
      console.error('[GW] error::processLogout()::', e)
    }
  }
}
